/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkApplyProjectDurationOverrunDto } from '../models/work-apply-project-duration-overrun-dto';
import { WorkProjectDurationOverrunDto } from '../models/work-project-duration-overrun-dto';

@Injectable({ providedIn: 'root' })
export class WorkProjectDurationOverrunV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectDurationOverrunV2ControllerFindByProjectId()` */
  static readonly ProjectDurationOverrunV2ControllerFindByProjectIdPath = '/v2/project-duration-overrun/project/{projectId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectDurationOverrunV2ControllerFindByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectDurationOverrunV2ControllerFindByProjectId$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectDurationOverrunDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectDurationOverrunV2Service.ProjectDurationOverrunV2ControllerFindByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectDurationOverrunDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectDurationOverrunV2ControllerFindByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectDurationOverrunV2ControllerFindByProjectId(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectDurationOverrunDto> {
    return this.projectDurationOverrunV2ControllerFindByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectDurationOverrunDto>): WorkProjectDurationOverrunDto => r.body)
    );
  }

  /** Path part for operation `projectDurationOverrunV2ControllerApplyToCalculation()` */
  static readonly ProjectDurationOverrunV2ControllerApplyToCalculationPath = '/v2/project-duration-overrun/project/{projectId}/apply';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectDurationOverrunV2ControllerApplyToCalculation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectDurationOverrunV2ControllerApplyToCalculation$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;
      body: WorkApplyProjectDurationOverrunDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectDurationOverrunDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectDurationOverrunV2Service.ProjectDurationOverrunV2ControllerApplyToCalculationPath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectDurationOverrunDto>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectDurationOverrunV2ControllerApplyToCalculation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectDurationOverrunV2ControllerApplyToCalculation(
    params: {

    /**
     * Project ID
     */
      projectId: number;
      body: WorkApplyProjectDurationOverrunDto
    },
    context?: HttpContext
  ): Observable<WorkProjectDurationOverrunDto> {
    return this.projectDurationOverrunV2ControllerApplyToCalculation$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectDurationOverrunDto>): WorkProjectDurationOverrunDto => r.body)
    );
  }

}
